module.exports = __webpack_public_path__ + "static/media/rdStation.2644d6e2.svg";